export const npsFormIds = {
  conventionVerification: "wM1oRp",
  conventionValidated: "nprlKZ",
};
